import React from 'react';
import { ScorePlayerCell } from 'components/scores';

class LeaderboardPlayerResult extends React.Component {
    constructor(props) {
        super(props);
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        this.setScrollToEnd();
    }

    componentDidUpdate() {
        this.setScrollToEnd();
    }

    setScrollToEnd = () => {
        const { scrollWidth, offsetWidth } = this.rootRef.current;

        this.rootRef.current.scrollLeft = scrollWidth - offsetWidth;
    };

    playerResult = () => {
        const { playOffRound } = this.props;

        if (!playOffRound || !Array.isArray(playOffRound.info)) return null;

        return (
            playOffRound.info.map((item, index) => {
                return (
                    <div
                        key={index}
                    >
                        <div className="leaderboard__player-result-row">
                            <div className="leaderboard__player-result-cell">{item.holeId}</div>
                        </div>
                        <div className="leaderboard__player-result-row">
                            <div className="leaderboard__player-result-cell">{item.holePar}</div>
                        </div>
                        <div className="leaderboard__player-result-row">
                            <div className="leaderboard__player-result-cell leaderboard__player-result-cell--score">
                                <ScorePlayerCell holePar={item.holePar} playerPar={item.playerPar} />
                            </div>
                        </div>
                    </div>
                );
            })
        );
    };

    render() {
        return (
            <div className="leaderboard__player-result" ref={this.rootRef}>
                {this.playerResult()}
            </div>
        );
    }
}

export default LeaderboardPlayerResult;
